"use client";

import { cn } from "@/lib/utils";

type Props = {
  className?: string;
};

export function ModelSelectProBadge({ className }: Props) {
  return (
    <span
      className={cn(
        "inline-flex h-5 shrink-0 items-center rounded-md border border-border bg-muted/30 px-1.5 text-[10px] leading-none font-medium tracking-[0.02em] text-muted-foreground",
        className,
      )}
    >
      PRO
    </span>
  );
}
